import { render } from "./DocVkView.vue?vue&type=template&id=2de01cb7"
import script from "./DocVkView.vue?vue&type=script&lang=js"
export * from "./DocVkView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__